import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ApiService, ChatMessage} from "../../../services/api.service";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {Subscription} from "rxjs";
import {DatePipe, DecimalPipe, JsonPipe, Location, NgForOf, NgIf, NgSwitch, NgSwitchCase} from "@angular/common";
import {DataTableComponent} from "../../../core/data-table/data-table.component";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatExpansionModule} from "@angular/material/expansion";

@Component({
  selector: 'app-session-chat-message-details',
  standalone: true,
  imports: [
    JsonPipe,
    NgIf,
    DataTableComponent,
    NgForOf,
    DatePipe,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    RouterLink,
    MatProgressBarModule,
    MatSidenavModule,
    MatExpansionModule,
    DecimalPipe,
    NgSwitchCase,
    NgSwitch
  ],
  templateUrl: './session-chat-message-details.component.html',
  styleUrl: './session-chat-message-details.component.sass'
})
export class SessionChatMessageDetailsComponent implements OnInit, OnDestroy {

  @Input() showToolbar: boolean = true
  @Output() readonly navigationChange = new EventEmitter<{
    stack: ChatMessage[]
  }>()

  loading = false
  error: any
  routeParamsSub?: Subscription
  result?: ChatMessage
  sessionId?: string
  showFullMessageText: boolean = false
  readonly navigationStack: ChatMessage[] = []

  constructor(
    readonly route: ActivatedRoute,
    readonly router: Router,
    readonly api: ApiService,
  ) {
  }

  get lastNavigationItem() {
    if (this.navigationStack.length) {
      return this.navigationStack[this.navigationStack.length - 1]
    }
    return undefined
  }

  isValidHttpUrl(value: any) {
    let url;
    try {
      url = new URL(value);
    } catch (_) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  }

  navigationStackPop() {
    if (this.navigationStack.length > 1) {
      const previousMessage = this.navigationStack[this.navigationStack.length - 2]
      this.loadMessage(previousMessage.id, 'pop')
    }
  }

  ngOnInit() {
    this.routeParamsSub = this.route.params.subscribe({
      next: (p) => {
        this.sessionId = p['sessionId']
        const messageId = p['messageId']
        this.loadMessage(messageId, 'push')
      }
    })
  }

  protected loadMessage(messageId: string, mode: 'push' | 'pop' | 'ignore') {
    if (this.sessionId && messageId) {
      const lastMessage = this.lastNavigationItem
      if (lastMessage && lastMessage.id == messageId) {
        return
      }
      this.error = undefined
      this.loading = true
      this.api.getSessionChatMessage(this.sessionId, messageId).subscribe({
        next: (message) => {
          this.result = message
          if (mode == 'push') {
            this.navigationStack.push(message)
            this.navigationChange.next({
              stack: this.navigationStack.slice()
            })
          }
          else if (mode == 'pop') {
            this.navigationStack.pop()
            this.navigationChange.next({
              stack: this.navigationStack.slice()
            })
          }
          else {

          }
          this.loading = false
        },
        error: (e) => {
          this.error = e
          this.loading = false
        }
      })
    }
  }

  ngOnDestroy(): void {
    this.routeParamsSub?.unsubscribe()
    this.routeParamsSub = undefined
  }

  dismiss() {
    if (this.sessionId) {
      this.router.navigate([
        'sessions/preview/', this.sessionId!, 'chat'
      ]).catch((e) => console.error('Router error', e))
        .finally(() => {
        })
    }
  }

  protected readonly Object = Object;
}
